var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.798,
    height: 20.903,
    viewBox: "0 0 18.798 20.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M14.637,11.921v5.238H9.4V11.921ZM13.56.417h2.1v2.1h1.028a2.09,2.09,0,0,1,2.105,2.1V19.214a2.09,2.09,0,0,1-2.1,2.105H2.1a2.032,2.032,0,0,1-1.493-.612A2.029,2.029,0,0,1,0,19.215V4.627A2.032,2.032,0,0,1,.612,3.133,2.029,2.029,0,0,1,2.1,2.522H3.133V.417h2.1v2.1H13.56Zm3.133,18.8V7.76H2.1V19.215Z",
    transform: "translate(0 -0.417)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8e9468c43ed5f790be1080ed4bc57f63.svg";
export { ForwardRef as ReactComponent };